// bao migrate skip
import template from "./pager.html";
import * as Pager from "./pager-module";
import * as ko from "knockout";
export default {
    viewModel: {
        createViewModel: function (params, componentInfo) {
            var e = componentInfo.element;
            var vm = null;
            ko.utils.domNodeDisposal.addDisposeCallback(e, () => {
                if (vm != null) {
                    vm.dispose();
                }
            });
            vm = new Pager.BaoPager(params);
            return vm;
        }
    },
    template: template
};